export default "assets/close-3d9ea37a.svg";